import type { SearchCacheBackend } from "@pdfking/compatibility"

export const MemoryCache = <V>(): SearchCacheBackend<V> => {
  const cache = new Map<string, V>()

  return {
    clear: async () => cache.clear(),
    delete: async (key: string) => void cache.delete(key),
    exists: async (key: string) => cache.has(key),
    get: async (key: string) => cache.get(key),
    set: async (key: string, value: V) => void cache.set(key, value),
    startswith: async (prefix?: string) =>
      Object.fromEntries(
        prefix
          ? [...cache.entries()].filter(([key]) => key.startsWith(prefix))
          : cache.entries()
      ),
  }
}
